module.exports = __webpack_public_path__ + "static/media/bmp.f3526ee4.svg";